export default {
  correspondant: {
    overview: 'Correspondent detail',
    name: 'Correspondent',
    search: {
      nomContactEtablissement: "Correspondent's Last name",
      prenomContactEtablissement: "Correspondent's First name",
      idSearchEtablissement: 'Company id',
      raisonSocialEtablissement: 'Social reason of the company',
      searchEntrepriseInsee: 'Only seat',
    },
    list: {
      title: 'List of Correspondents',
      headers: {
        id: 'Id',
        civilite: 'Civility',
        name: 'Last name',
        mail: 'E-Mail',
        telfixe: 'Phone',
        telPortable: 'Cellphone',
        etablissementRaisonSociale: 'Social reason of the company',
        entrepriseRaisonSociale: 'Social reason of the head office',
        groupementRaisonSociale: 'Social reason of the group',
      },
    },
    details: {
      id: 'Id',
      civilite: 'Civility',
      nom: 'Last name',
      prenom: 'First name',
      telFixe: 'Phone',
      telPortable: 'Cellphone',
      fax: 'Fax',
      mail: 'E-Mail',
      fonction: 'Function',
      etablissementId: 'Identifier of the affiliated company',
      etablissementRaisonSociale: 'Social reason of the affiliated company',
      entrepriseInseeId: 'Seat identifier',
      entrepriseInseeRaisonSociale: 'Social reason of the seat',
      groupementId: 'Group identifier',
      groupementRaisonSociale: 'Social reason of the group',
      roleAdmin: 'Administration',
      roleFacturation: 'Facturation',
      roleEnvoiCourrier: 'Sending mail',
      contact: 'Contact details',
      etablissementRattachement: 'Affiliated company',
      entrepriseInseeRattachement: 'Affiliated seat',
      groupementRattachement: 'Affiliated group',
      role: 'Correspondent roles',
    },
  },
}
